import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { styled } from 'styled-components';
import { Gender } from '@debbie/common/dist/index.js';
import { getCourtByCountryCode } from '@debbie/common/dist/court/index.js';
import { cvrStatuses, cvrBranches, companyTypes, } from '@debbie/common/dist/cvr/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { Checkbox, ButtonGroup } from '../..//index.js';
import Button from '../../Button.js';
import Frown from '../../Icons/Frown.js';
import Meh from '../../Icons/Meh.js';
import Smile from '../../Icons/Smile.js';
import RangeInput from '../../RangeInput.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const ContactsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const courts = getCourtByCountryCode(tenant?.countryCode) || [];
    return (React.createElement(FilterGroup, { name: lang.caseFilter.contactsGroup },
        React.createElement(FilterOption, { active: !!caseFilter.maxRkiRegistrations, header: lang.caseFilter.maxRkiRegistrations, subheader: lang.caseFilter.maxRkiRegistrationsSub, onDeactivate: () => c.insights.clearFilter('maxRkiRegistrations') },
            React.createElement(RangeInput, { minValue: 0, maxValue: 30, value: caseFilter.maxRkiRegistrations || 0, updateWhenSteady: true, onChange: (val) => {
                    if (typeof val === 'number')
                        c.insights.updateFilter({
                            maxRkiRegistrations: val,
                        });
                } })),
        React.createElement(FilterOption, { active: !!caseFilter.minRkiRegistrations, header: lang.caseFilter.minRkiRegistrations, subheader: lang.caseFilter.minRkiRegistrationsSub, onDeactivate: () => c.insights.clearFilter('minRkiRegistrations') },
            React.createElement(RangeInput, { minValue: 0, maxValue: 30, value: caseFilter.minRkiRegistrations || 0, updateWhenSteady: true, onChange: (val) => {
                    if (typeof val === 'number')
                        c.insights.updateFilter({
                            minRkiRegistrations: val,
                        });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.isReportedByCollector === 'boolean', header: lang.caseFilter.rkiRegisteredByCollector, onDeactivate: () => c.insights.clearFilter('isReportedByCollector') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isReportedByCollector === true, onClick: () => c.insights.updateFilter({
                        isReportedByCollector: true,
                    }) }, lang.caseFilter.isRegisteredByCollector),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isReportedByCollector === false, onClick: () => c.insights.updateFilter({
                        isReportedByCollector: false,
                    }) }, lang.caseFilter.isNotRegisteredByCollector))),
        React.createElement(FilterOption, { active: typeof caseFilter.hasEmail === 'boolean', header: lang.caseFilter.contactHasEmail, onDeactivate: () => c.insights.clearFilter('hasEmail') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.hasEmail, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            hasEmail: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('hasEmail');
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.hasAddress === 'boolean', header: lang.caseFilter.contactHasAddress, onDeactivate: () => c.insights.clearFilter('hasAddress') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.hasAddress, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            hasAddress: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('hasAddress');
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.hasPhone === 'boolean', header: lang.caseFilter.contactHasPhone, onDeactivate: () => c.insights.clearFilter('hasPhone') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.hasPhone, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            hasPhone: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('hasPhone');
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.hasAlternativeContact === 'boolean', header: lang.caseFilter.contactPersonIs, onDeactivate: () => c.insights.clearFilter('hasAlternativeContact') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.hasAlternativeContact === true, onClick: () => c.insights.updateFilter({
                        hasAlternativeContact: true,
                    }) }, lang.caseFilter.alternativeContact),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.hasAlternativeContact === false, onClick: () => c.insights.updateFilter({
                        hasAlternativeContact: false,
                    }) }, lang.caseFilter.debtor))),
        React.createElement(FilterOption, { active: typeof caseFilter.isCompany === 'boolean', header: lang.caseFilter.contactPersonIs, onDeactivate: () => c.insights.clearFilter('isCompany') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isCompany === true, onClick: () => c.insights.updateFilter({
                        isCompany: true,
                    }) }, lang.caseFilter.company),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isCompany === false, onClick: () => c.insights.updateFilter({
                        isCompany: false,
                    }) }, lang.caseFilter.person))),
        React.createElement(FilterOption, { active: typeof caseFilter.activePaymentMethod === 'boolean', header: lang.caseFilter.paymentMethod, onDeactivate: () => c.insights.clearFilter('activePaymentMethod') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.activePaymentMethod === true, onClick: () => c.insights.updateFilter({
                        activePaymentMethod: true,
                    }) }, lang.caseFilter.hasCard),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.activePaymentMethod === false, onClick: () => c.insights.updateFilter({
                        activePaymentMethod: false,
                    }) }, lang.caseFilter.doNotHaveCard))),
        React.createElement(FilterOption, { active: !!(caseFilter.companyStatuses && caseFilter.companyStatuses.length), header: lang.caseFilter.companyStatus, onDeactivate: () => c.insights.clearFilter('companyStatuses') },
            React.createElement(Select, { value: (caseFilter.companyStatuses || []).map((status) => ({
                    label: status,
                    value: status,
                })), isMulti: true, placeholder: lang.caseFilter.selectCompanyStatus, classNamePrefix: "select", options: cvrStatuses.map((status) => ({
                    label: status,
                    value: status,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        companyStatuses: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.courtIds && caseFilter.courtIds.length), header: lang.caseFilter.court, onDeactivate: () => c.insights.clearFilter('courtIds') },
            React.createElement(Select, { value: (caseFilter.courtIds || []).map((id) => {
                    const court = courts.find((c) => c.id === id);
                    return {
                        label: court && court.name,
                        value: id,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCourt, classNamePrefix: "select", options: courts.map((court) => ({
                    label: court.name,
                    value: court.id,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        courtIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.companyBranches && caseFilter.companyBranches.length), header: lang.caseFilter.companyBranch, onDeactivate: () => c.insights.clearFilter('companyBranches') },
            React.createElement(Select, { value: (caseFilter.companyBranches || []).map((companyBranchId) => {
                    const companyBranch = cvrBranches[companyBranchId];
                    return {
                        label: companyBranch,
                        value: companyBranchId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCompanyBranch, classNamePrefix: "select", options: Object.entries(cvrBranches).map((entry) => {
                    return {
                        label: entry[1],
                        value: entry[0],
                    };
                }), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        companyBranches: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.companyTypes && caseFilter.companyTypes.length), header: lang.caseFilter.companyTypes, onDeactivate: () => c.insights.clearFilter('companyTypes') },
            React.createElement(Select, { value: (caseFilter.companyTypes || []).map((type) => {
                    return {
                        label: type,
                        value: type,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCompanyTypes, classNamePrefix: "select", options: companyTypes.map((type) => {
                    return {
                        label: type,
                        value: type,
                    };
                }), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        companyTypes: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!caseFilter.gender, header: lang.caseFilter.gender, onDeactivate: () => c.insights.clearFilter('gender') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.gender === Gender.MALE, onClick: () => c.insights.updateFilter({
                        gender: Gender.MALE,
                    }) }, lang.caseFilter[Gender.MALE]),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.gender === Gender.FEMALE, onClick: () => c.insights.updateFilter({
                        gender: Gender.FEMALE,
                    }) }, lang.caseFilter[Gender.FEMALE]))),
        React.createElement(FilterOption, { active: !!(caseFilter.withSatisfactions && caseFilter.withSatisfactions.length), header: lang.caseFilter.satisfactions, onDeactivate: () => c.insights.clearFilter('withSatisfactions') },
            React.createElement(SmileySelect, null,
                React.createElement(SmileySelectItem, { selected: !!(caseFilter.withSatisfactions &&
                        caseFilter.withSatisfactions.find((s) => s === 1)), onClick: () => {
                        const selected = !!(caseFilter.withSatisfactions &&
                            caseFilter.withSatisfactions.find((s) => s === 1));
                        c.insights.updateFilter({
                            withSatisfactions: selected
                                ? (caseFilter.withSatisfactions || []).filter((s) => s !== 1)
                                : (caseFilter.withSatisfactions || []).concat(1),
                        });
                    } },
                    React.createElement(Frown, null)),
                React.createElement(SmileySelectItem, { selected: !!(caseFilter.withSatisfactions &&
                        caseFilter.withSatisfactions.find((s) => s === 3)), onClick: () => {
                        const selected = !!(caseFilter.withSatisfactions &&
                            caseFilter.withSatisfactions.find((s) => s === 3));
                        c.insights.updateFilter({
                            withSatisfactions: selected
                                ? (caseFilter.withSatisfactions || []).filter((s) => s !== 3)
                                : (caseFilter.withSatisfactions || []).concat(3),
                        });
                    } },
                    React.createElement(Meh, null)),
                React.createElement(SmileySelectItem, { selected: !!(caseFilter.withSatisfactions &&
                        caseFilter.withSatisfactions.find((s) => s === 5)), onClick: () => {
                        const selected = !!(caseFilter.withSatisfactions &&
                            caseFilter.withSatisfactions.find((s) => s === 5));
                        c.insights.updateFilter({
                            withSatisfactions: selected
                                ? (caseFilter.withSatisfactions || []).filter((s) => s !== 5)
                                : (caseFilter.withSatisfactions || []).concat(5),
                        });
                    } },
                    React.createElement(Smile, null))))));
};
export default ContactsGroup;
const SmileySelect = styled.div `
  font-size: 2em;
`;
const SmileySelectItem = styled.div `
  cursor: pointer;
  margin: 0 5px;
  padding: 10px 8px 1px 8px;
  border-radius: 4px;
  display: inline-block;

  background-color: ${(props) => props.selected ? 'lightgrey' : 'transparent'};
`;
//# sourceMappingURL=ContactsGroup.js.map